module.exports = __webpack_public_path__ + "static/media/dragdonat.2cb8dc27.mov";